import axios from "axios";
import store from "@/store";
import router from "@/router";

function handleUnauthorized(error) {
  console.log("handleUnauthorized", error?.response);
  if (error.response && error.response.status === 401) {
    store.commit("setUser", null);
    if (router.currentRoute.value.name !== "Login") {
      router.push({ name: "Login" });
    }
  }
  return Promise.reject(error);
}
// console.log("axios", axios.interceptors.request);
// axios.interceptors.request.use(config => {
//   // Yanıt gönderilmeden önce bir şey yap
//   alert("sdfsdf");
//   console.log("interceptors", config);
//   return 'sdfdsf';
// });

export const appAxiosAdmin = axios.create({
  baseURL: "https://api.kolayrez.com/Admin/",
  headers: {
    Authorization: store.state.user?.Token
  },
});
export const appAxiosTourscope = axios.create({
  baseURL: "https://api.kolayrez.com/Tourscope/",
  headers: {
    Authorization: store.state.user?.Token
  }
});
export const appAxiosKolayrez = axios.create({
  baseURL: "https://api.kolayrez.com/Kolayrez/",
  headers: {
    Authorization: store.state.user?.Token
  }
});
export const appAxios = axios.create({
  baseURL: "https://api.kolayrez.com/Users/",
  headers: {
    Authorization: store.state.user?.Token
  }
});
export const appAxiosOther = axios.create();

const instances = [
  appAxiosAdmin,
  appAxiosTourscope,
  appAxiosKolayrez,
  appAxios,
  appAxiosOther,
];

instances.forEach((instance) => {
  instance.interceptors.response.use((response) => response, handleUnauthorized);
});

if (process.env.NODE_ENV == "development") {
  appAxiosAdmin.interceptors.request.use(interceptorsRequest);
  appAxiosTourscope.interceptors.request.use(interceptorsRequest);
  appAxiosKolayrez.interceptors.request.use(interceptorsRequest);
  appAxios.interceptors.request.use(interceptorsRequest);
}
function interceptorsRequest(config) {
  if (process.env.NODE_ENV == 'development') {
    store._mutations.setRequestWatch[0](config);
  }
  return config;
}

